import { Attendee } from 'src/types/types';
import { API_INSTANCE, buildURL } from 'src/features/utils';

export async function sendLoginInit(email: Attendee['email'], recaptchaToken?: string) {
  return await API_INSTANCE.post('/api/v1/auth/login/init', {
    email: email.trim(),
    'g-recaptcha-response': recaptchaToken,
  });
}

export async function loginApi(
  email: Attendee['email'],
  password: string,
  isAttendeeLogin: boolean,
  recaptchaToken?: string,
) {
  return await API_INSTANCE.post('/api/v1/auth/login', {
    email,
    password,
    attendee_login: isAttendeeLogin,
    'g-recaptcha-response': recaptchaToken,
  });
}

export async function sendPinCodeApi(
  site: unknown,
  email: Attendee['email'],
  recaptchaToken?: string,
) {
  return await API_INSTANCE.post(`/api/v1/auth/code-sender`, {
    email,
    'g-recaptcha-response': recaptchaToken,
  });
}

export async function verifyPinCodeApi(
  site: unknown,
  email: Attendee['email'],
  captchaToken: string,
  inputCode: string,
  codeId: string,
  attendeeLogin: boolean,
) {
  return API_INSTANCE.post(`/api/v1/auth/login`, {
    email,
    'g-recaptcha-response': captchaToken,
    attendee_login: attendeeLogin,
    code_verification: {
      code: inputCode,
      id: codeId,
    },
  });
}
